module.exports = __webpack_public_path__ + "assets/svg/Icons/32/groups-gray-1be275.svg";